<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">Cadatrar Usuário</p>
      <span
        style="cursor: pointer"
        class="row justify-end q-mt-md q-mb-md"
        @click="backPage"
      >
        <div @click="backPage" class="row align-center">
          <q-icon
            label="voltar"
            class="q-mr-sm"
            color="grey"
            size="sm"
            name="west"
          />
          <span style="color: #8a8a8a; font-size: 20px">Voltar</span>
        </div>
      </span>
    </div>
    <p class="text-brand-1">
      Preencha as informações abaixo para cadastrar um novo usuário. Depois de
      criar o usuário você será direcionado para a tela de detalhes.
    </p>
    <div class="row col-12 q-gutter-sm q-mt-md text-brand-5 text-weight-bold">
      <div class="col-2 col-xs-5">
        <div class="q-ml-sm">Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-5 col-xs-5">
        <div class="q-ml-sm">Centro de Custo</div>
        <q-select
          label="Centro de Custo"
          class="input-new-design"
          dense
          outlined
          v-model="dados.centroCusto"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          hide-bottom-space
          @filter="filtrarCentro"
          :options="options.centros"
          :option-label="
            (opt) => (Object(opt) === opt && 'name' in opt ? opt.name : '')
          "
        />
      </div>
      <div class="col-5 col-xs-5 q-mt-md q-mb-md">
        <div class="q-ml-sm">Nome</div>
        <q-input
          ref="inputRef"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          label="Nome"
          class="input-new-design"
          dense
          outlined
          v-model="dados.nome"
          hide-bottom-space
        />
      </div>
      <div class="col-5 col-xs-5 q-mt-md q-mb-md">
        <div class="q-ml-sm">GHE</div>
        <q-select
          outlined
          dense
          v-model="dados.ghe"
          :options="funcoes"
          option-value="id"
          behavior="menu"
          map-options
          label="GHE"
          use-input
          option-label="name"
          @filter="filtrarGhe"
        >
        </q-select>
      </div>

      <div class="col-2 col-xs-5">
        <div class="q-ml-sm">Matricula</div>
        <q-input
          ref="inputRef2"
          label="Matricula, Sap, RE, ID ou outro identificado único"
          dense
          class="input-new-design"
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          @keyup="conexaoEmail"
          v-model="dados.id"
          hide-bottom-space
        />
      </div>

      <div class="col-2 col-xs-5">
        <div class="q-ml-sm">Email</div>
        <q-input
          ref="inputRef3"
          label="Email corporativo válido"
          dense
          class="input-new-design"
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          v-model="dados.email"
          hide-bottom-space
        />
      </div>
    </div>
    <div>
      <p></p>
      <q-btn
        icon="add"
        no-caps
        style="border-radius: 8px"
        class="q-mt-sm"
        color="brand-1"
        label="Criar Usuario"
        @click="criarUsuario"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const unidade = ref();
    const dados = ref({
      nome: "",
      id: "",
      email: "",
      centroCusto: "",
      ghe: "",
    });
    const options = ref({ centros: [] });

    const inputRef = ref(null);
    const inputRef2 = ref(null);
    const inputRef3 = ref(null);
    const funcoes = ref([]);
    const criarUsuario = async () => {
      for (const vazios in dados.value) {
        if (dados.value[vazios] == "") {
          quasar.notify({
            message: "Preencha todos os campos",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }

      try {
        let response = await store.dispatch("user/criarUsuario", {
          vendor_id: store.state.org.unidadeData.id,
          name: dados.value.nome,
          sap: dados.value.id,
          email: dados.value.email,
          cost_center_id: dados.value.centroCusto.id,
          function_id: dados.value?.ghe?.id,
        });

        quasar.notify({
          message: "Usuario criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        for (const vazios in dados.value) {
          dados.value[vazios] = "";
        }

        await inputRef.value.resetValidation();
        await inputRef2.value.resetValidation();
        await inputRef3.value.resetValidation();

        router.push({
          name: "usuario-editar",
          params: { id: response.data.model.id },
        });
      } catch (error) {
        if (
          error.response.data.errors.sap[0] ===
          "The sap has already been taken."
        ) {
          quasar.notify({
            message: "Já existe um usuário com está matricula.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Erro ao criar usuário.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarCentroCusto = async () => {
      try {
        const response = await store.dispatch("user/getCentros", {
          vendor_id: store.state.org.unidadeData.id,
        });
        options.value.centros = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const conexaoEmail = async () => {
      let subdomain = window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : false;

      dados.value.email = dados.value.id;
      dados.value.email = `${dados.value.email}@${subdomain}.com.br`;
      if (dados.value.id == "") {
        dados.value.email = "";
      }
    };

    const getFunctions = async (value) => {
      let response = await store.dispatch("user/getFuncoes", {
        vendor_id: store.state.org.unidadeData.id,
        search: value,
      });
      funcoes.value = response.data.results.data;
    };

    const backPage = async () => {
      router.push({ name: "spf-user" });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      dados,
      criarUsuario,
      conexaoEmail,
      inputRef,
      inputRef2,
      listarCentroCusto,
      filtrarCentro(val, update) {
        listarCentroCusto(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      options,
      inputRef3,
      unidade,
      backPage,
      funcoes,
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}
.align-center {
  align-items: center;
}
</style>
